import * as React from "react";
import cx from "classnames";
import isEven from "@functions/isEven";
import * as classess from "@styles/screen.module.css";



const Screen = (props) => {
  let counter = props.counter;
  console.log("counter: ", counter);
  return (
    <section
      id={props.id}
      className={cx(
        isEven(counter) ? classess.bg_first : classess.bg_second,
        props.first ? classess.screen_first : classess.screen
      )}
    >
      {props.children}
    </section>
  );
};

export default Screen;
